import React, { useContext, useEffect, useState } from 'react';
import { UnitUtility } from '@bmsp/bmsp.web.component.common';
import {
  addMonths,
  differenceInDays,
  endOfMonth,
  format,
  getDaysInMonth,
  isSameMonth,
  startOfMonth,
  differenceInMonths,
  startOfYear,
  endOfYear,
  differenceInHours,
  addDays
} from 'date-fns';
import { DataTable } from '@scuf/datatable';
import { IEnergyTableOptimizationWidgetProps } from '../EnergyOptimizationInterfaces';
import { useTranslation } from '@scuf/localization';
import './EnergyOptimizationTableWidgetTheme.scss';
import {
  formatCurrency,
  formatPriceValue,
  formatUnit,
  splitStringWithSpace
} from '../../../shared/Utils/Utils';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import {
  ConversionType,
  getMaxConvertedValueFromArray
} from '../../../../main';
import tr from 'date-fns/esm/locale/tr/index';
import { IAny } from '../../IEnergyManagementProps';
import descriptors from '../../../../locales/en-US/descriptors';
import { ApiContext } from '../../../../context/ApiContext';
import { Loader } from '@scuf/common';
const d: IAny = descriptors.energyManagement;

const EnergyOptimizationTableWidget = (
  props: IEnergyTableOptimizationWidgetProps
) => {
  const {
    startTime,
    endTime,
    isAllUtility,
    data,
    utilityType,
    eoOperationData,
    dataOp
  } = props;
  const [t] = useTranslation();
  const [tableData, setTableData] = useState<any[]>([]);

  const apiContext = useContext(ApiContext);

  const mapping: { [key: string]: string } = {
    On: '1',
    'EO Not Optimizing': '2',
    'Planned Off for Improving Baseline': '3',
    'Switched Off from Cloud': '4',
    'Switched Off from Site': '5'
  };

  const savingsDesign = (value: any, unit: any) => (
    <div>
      <span className="emaas-summary-value actual-cost">
        {formatPriceValue(formatCurrency(value!, unit))}
      </span>
      <span className="emaas-summary-unit">
        {formatUnit(formatCurrency(value!, unit))}
      </span>
    </div>
  );

  const savingsDesignOthers = (
    utilityType: any,
    userPreferedUnit: any,
    fromUnit: any,
    valuesArray: any
  ) => {
    let conversionType = ConversionType.ELECTRICITY;
    switch (utilityType.toLowerCase()) {
      case 'gas':
        conversionType = ConversionType.GAS;
        break;
      case 'steam':
        conversionType = ConversionType.STEAM;
        break;
      case 'water':
        conversionType = ConversionType.WATER;
        break;
    }
    return getMaxConvertedValueFromArray(
      conversionType,
      userPreferedUnit || fromUnit,
      valuesArray,
      fromUnit
    );
  };
  const getUnitSymbolForTemp = (unitName: any) => {
    if (unitName.toLowerCase() === 'celsius') return '°C';
    else return '°F';
  };

  const enum EoViewDetailsKeys {
    ACTUALCOST = 'ActualCost',
    BASECOST = 'BaseCost',
    ADJUSTMENTSAVINGS = 'AdjustmentSavings',
    DAYTYPE = 'DayType',
    ELECTRICITYUNIT = 'kilowatt hour',
    ACTIVEDURATION = 'ActiveDuration',
    EMSPOACTIVE = 'IsEmsopActive',
    ADJUSTMENTBASECOST = 'AdjustmentBaseCost',
    CUBICMETER = 'cubic meter',
    KILOGRAM = 'kilogram'
  }

  const calculateActiveHoursForPastDays = (data: IAny) => {
    const secondsOfDay = 86400;
    let optimizationDayType = data?.filter(
      (dt: { [key: string]: string }) => dt.name === EoViewDetailsKeys.DAYTYPE
    )[0];
    let enabledDates = optimizationDayType?.values
      ?.filter((x: { [key: string]: string | number }) => {
        if (x.value === 0 || x.value === 2) {
          return x;
        }
      })
      ?.map((y: { [key: string]: string }) => y.dataTimeStamp);

    let activeDurations = data?.filter(
      (dt: { [key: string]: string }) =>
        dt.name === EoViewDetailsKeys.ACTIVEDURATION
    )[0];

    if (activeDurations === null) {
      return;
    }

    return activeDurations?.values?.filter((x: { [key: string]: string }) =>
      enabledDates?.includes(x.dataTimeStamp)
    );
  };

  const includeActiveHoursInData = (
    eoStatusRuntime: IAny,
    activeHours: IAny
  ) => {
    eoStatusRuntime?.values?.forEach((eoStatus: IAny) => {
      if (
        eoStatus &&
        eoStatus.properties &&
        Object.keys(eoStatus.properties).length === 0
      ) {
        // if(activeHours && activeHours.length)
        let ind = activeHours?.findIndex(
          (activeHour: { [key: string]: string }) =>
            activeHour.dataTimeStamp.split('T')[0] ===
            eoStatus.dataTimeStamp.split('T')[0]
        );
        if (ind !== -1) {
          const hours = (activeHours[ind].value * 24) / 86400;
          eoStatus.properties['1'] = hours.toString();
        }
        return false;
      } else {
        return true;
        // do nothing
      }
    });
  };

  useEffect(() => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const diffDays = differenceInDays(end, start) + 1;
    const diffMonths = differenceInMonths(end, start) + 1;
    const daysInMonth = getDaysInMonth(start);

    // let activeHours = isAllUtility
    //   ? calculateActiveHoursForPastDays(data?.dataItems)
    //   : apiContext.eoActiveHours;

    // let activeHours = calculateActiveHoursForPastDays(data?.dataItems)

    const columns = getColumns(start, end, diffDays, diffMonths, daysInMonth);
    let eoStatusRuntime: IAny;
    if (isAllUtility) {
      eoStatusRuntime = data?.dataItems?.find(
        (item) => item.name === 'EOStatusRuntime'
      );
    } else {
      eoStatusRuntime = eoOperationData?.dataItems?.find(
        (item) => item.name === 'EOStatusRuntime'
      );
    }

    includeActiveHoursInData(eoStatusRuntime, apiContext.eoActiveHours);

    const savings = data?.dataItems?.find(
      (item) => item.name === 'AdjustmentSavings'
    );

    const transformedData = [];
    const eoOperationOverviewRow: { parameters: string; [key: string]: any } = {
      parameters: 'EO Operation Overview'
    };
    const operationParametersRow: { parameters: string; [key: string]: any } = {
      parameters: 'Operation Parameters'
    };

    const addSavingsRow = (
      aggregatedValue: number,
      unit: string | null | undefined,
      formattedDate: string
    ) => {
      return aggregatedValue > 0
        ? isAllUtility
          ? savingsDesign(aggregatedValue, unit)
          : `${
              savingsDesignOthers(utilityType, '', unit, [aggregatedValue])
                .Value
            } ${
              savingsDesignOthers(utilityType, '', unit, [aggregatedValue]).Unit
            }`
        : isAllUtility
        ? savingsDesign(0, unit)
        : `${savingsDesignOthers(utilityType, '', unit, [0]).Value} ${
            savingsDesignOthers(utilityType, '', unit, [0]).Unit
          }`;
    };

    const savingsRow: { parameters: string; [key: string]: any } = {
      parameters: `Savings ${isAllUtility ? '(Cost)' : '(Units)'}`
    };
    if (savings) {
      if (diffMonths > 12) {
        let currentYear = startOfYear(start);
        while (currentYear <= end) {
          const yearEnd = endOfYear(currentYear);
          const hasDataForYear = savings.values.some(
            (value: { dataTimeStamp: string | number | Date }) => {
              const date = new Date(value.dataTimeStamp);
              return date >= currentYear && date <= yearEnd;
            }
          );
          if (!hasDataForYear) {
            savingsRow[format(currentYear, 'yyyy')] = '--';
          } else {
            const aggregatedValue = savings.values.reduce((acc, value) => {
              const date = new Date(value.dataTimeStamp);
              return date >= currentYear && date <= yearEnd
                ? acc + value.value
                : acc;
            }, 0);
            savingsRow[format(currentYear, 'yyyy')] = addSavingsRow(
              aggregatedValue,
              isAllUtility ? apiContext.currencyCode : savings.unit,
              format(currentYear, 'yyyy')
            );
          }
          currentYear = addMonths(currentYear, 12);
        }
      } else if (diffDays > 7) {
        let currentMonth = startOfMonth(start);
        while (currentMonth <= end) {
          const monthEnd = endOfMonth(currentMonth);
          const hasDataForMonth = savings.values.some(
            (value: { dataTimeStamp: string | number | Date }) => {
              const date = new Date(value.dataTimeStamp);
              return date >= currentMonth && date <= monthEnd;
            }
          );
          if (!hasDataForMonth) {
            savingsRow[format(currentMonth, 'MMMM yyyy')] = '--';
          } else {
            const aggregatedValue = savings.values.reduce((acc, value) => {
              const date = new Date(value.dataTimeStamp);
              return date >= currentMonth && date <= monthEnd
                ? acc + value.value
                : acc;
            }, 0);
            savingsRow[format(currentMonth, 'MMMM yyyy')] = addSavingsRow(
              aggregatedValue,
              isAllUtility ? apiContext.currencyCode : savings.unit,
              format(currentMonth, 'MMMM yyyy')
            );
          }
          currentMonth = addMonths(currentMonth, 1);
        }
      } else if (isSameMonth(start, end) && diffDays === daysInMonth) {
        const hasDataForMonth = savings.values.some(
          (value: { dataTimeStamp: string | number | Date }) => {
            const date = new Date(value.dataTimeStamp);
            return date >= start && date <= end;
          }
        );
        if (!hasDataForMonth) {
          savingsRow[format(start, 'MMM yyyy')] = '--';
        } else {
          const aggregatedValue = savings.values.reduce(
            (acc, value) => acc + value.value,
            0
          );
          savingsRow[format(start, 'MMM yyyy')] = addSavingsRow(
            aggregatedValue,
            isAllUtility ? apiContext.currencyCode : savings.unit,
            format(start, 'MMM yyyy')
          );
        }
      } else if (diffDays <= 7) {
        savings.values.forEach((value) => {
          const date = new Date(value.dataTimeStamp);
          const formattedDate = format(date, 'dd MMM - EEE');
          if (columns.some((col) => col.field === formattedDate)) {
            savingsRow[formattedDate] = addSavingsRow(
              value.value,
              isAllUtility ? apiContext.currencyCode : savings.unit,
              formattedDate
            );
          }
        });
        // Check for missing dates and add "--" for those dates
        const startDate = new Date(startTime);
        const endDate = new Date(endTime);
        for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
          const formattedDate = format(d, 'dd MMM - EEE');
          if (
            !savingsRow[formattedDate] &&
            columns.some((col) => col.field === formattedDate)
          ) {
            savingsRow[formattedDate] = '--';
          }
        }
      }
    } else {
      // If savings is false, populate savingsRow with "--" for each date in the range
      if (diffMonths > 12) {
        let currentYear = startOfYear(start);
        while (currentYear <= end) {
          savingsRow[format(currentYear, 'yyyy')] = '--';
          currentYear = addMonths(currentYear, 12);
        }
      } else if (diffDays > 7) {
        let currentMonth = startOfMonth(start);
        while (currentMonth <= end) {
          savingsRow[format(currentMonth, 'MMMM yyyy')] = '--';
          currentMonth = addMonths(currentMonth, 1);
        }
      } else if (isSameMonth(start, end) && diffDays === daysInMonth) {
        savingsRow[format(start, 'MMM yyyy')] = '--';
      } else if (diffDays <= 7) {
        const startDate = new Date(startTime);
        const endDate = new Date(endTime);
        for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
          const formattedDate = format(d, 'dd MMM - EEE');
          savingsRow[formattedDate] = '--';
        }
      }
    }
    transformedData.push(savingsRow);
    if (eoStatusRuntime) {
      const eoStatusData = Object.keys(mapping).map((key) => {
        const row: { parameters: string; [key: string]: any } = {
          parameters: key
        };
        const addEoStatusRow = (
          aggregatedValue: number | undefined,
          formattedDate: string,
          hoursForPercentage: number = 24
        ) => {
          row[formattedDate] =
            aggregatedValue !== undefined
              ? aggregatedValue >= 0
                ? `${aggregatedValue.toFixed(1)} hrs (${(
                    (aggregatedValue / hoursForPercentage) *
                    100
                  ).toFixed(1)}%)`
                : '--'
              : '--';
        };

        if (diffMonths > 12) {
          let currentYear = startOfYear(start);
          while (currentYear <= end) {
            const yearEnd = endOfYear(currentYear);

            const hour = differenceInHours(
              addDays(new Date(currentYear), 1),
              new Date(yearEnd)
            );

            const hasDataForYear = eoStatusRuntime.values.some(
              (value: { dataTimeStamp: string | number | Date }) => {
                const date = new Date(value.dataTimeStamp);
                return date >= currentYear && date <= yearEnd;
              }
            );
            if (!hasDataForYear) {
              row[format(currentYear, 'yyyy')] = '--';
            } else {
              const aggregatedValue = eoStatusRuntime.values.reduce(
                (
                  acc: number,
                  value: {
                    value: number;
                    dataTimeStamp: string | number | Date;
                    properties: { [x: string]: string };
                  }
                ) => {
                  const date = new Date(value.dataTimeStamp);
                  if (
                    date >= currentYear &&
                    date <= yearEnd &&
                    // value.value === 1 &&
                    value.properties
                  ) {
                    let yearformat = format(currentYear, 'yyyy');

                    if (
                      !eoStatusRuntime.values
                        .filter((v: { dataTimeStamp: number | Date }) => {
                          const dates = new Date(v.dataTimeStamp);
                          const monthNames = format(dates, 'yyyy');
                          return monthNames === yearformat;
                        })
                        .some(
                          (v: { properties: { [x: string]: any } }) =>
                            v.properties && v.properties[mapping[key]]
                        )
                    ) {
                      return '--';
                    } else if (value.properties[mapping[key]]) {
                      return typeof acc === 'number'
                        ? acc + parseFloat(value.properties[mapping[key]])
                        : parseFloat(value.properties[mapping[key]]);
                    }
                  }
                  return acc;
                },
                0
              );
              addEoStatusRow(aggregatedValue, format(currentYear, 'yyyy'));
            }
            currentYear = addMonths(currentYear, 12);
          }
        } else if (diffDays > 7) {
          let currentMonth = startOfMonth(start);
          while (currentMonth <= end) {
            const monthEnd = endOfMonth(currentMonth);
            let daysDiff = 0;
            if (end < monthEnd && currentMonth >= start) {
              daysDiff = differenceInDays(end, currentMonth) + 1;
            } else if (end < monthEnd && currentMonth < start) {
              daysDiff = differenceInDays(end, start) + 1;
            } else if (end > monthEnd && currentMonth < start) {
              daysDiff = differenceInDays(monthEnd, start) + 1;
            } else {
              daysDiff = differenceInDays(monthEnd, currentMonth) + 1;
            }
            const hoursForPercentage = daysDiff * 24;
            const hasDataForMonth = eoStatusRuntime.values.some(
              (value: { dataTimeStamp: string | number | Date }) => {
                const date = new Date(value.dataTimeStamp);
                return date >= currentMonth && date <= monthEnd;
              }
            );

            if (!hasDataForMonth) {
              row[format(currentMonth, 'MMMM yyyy')] = '--';
            } else {
              const aggregatedValue = eoStatusRuntime.values.reduce(
                (
                  acc: number,
                  value: {
                    value: number;
                    dataTimeStamp: string | number | Date;
                    properties: { [x: string]: string };
                  }
                ) => {
                  const date = new Date(value.dataTimeStamp);
                  const monthName = format(currentMonth, 'MMMM'); // "MMMM" will give you the full month name
                  const yearName = format(currentMonth, 'yyyy'); // "MMMM" will give you the full month name
                  if (
                    date >= currentMonth &&
                    date <= monthEnd &&
                    value.properties
                  ) {
                    let filterdData = eoStatusRuntime.values.filter(
                      (v: { value: number; dataTimeStamp: number | Date }) => {
                        const dates = new Date(v.dataTimeStamp);
                        const monthNames = format(dates, 'MMMM');
                        const yearNames = format(dates, 'yyyy');
                        return (
                          monthNames === monthName && yearNames === yearName
                          // v.value === 1
                        );
                      }
                    );

                    let checkData =
                      filterdData && filterdData.length > 0
                        ? !filterdData.some(
                            (v: { properties: { [x: string]: any } }) =>
                              v.properties && v.properties[mapping[key]]
                          )
                        : true;

                    if (checkData) {
                      return '--';
                    } else if (value.properties[mapping[key]]) {
                      return typeof acc === 'number'
                        ? acc + parseFloat(value.properties[mapping[key]])
                        : parseFloat(value.properties[mapping[key]]);
                    }
                  }
                  return acc;
                },
                0
              );

              addEoStatusRow(
                aggregatedValue,
                format(currentMonth, 'MMMM yyyy'),
                hoursForPercentage
              );
            }
            currentMonth = addMonths(currentMonth, 1);
          }
        } else if (
          isSameMonth(start as IAny, end as IAny) &&
          diffDays === daysInMonth
        ) {
          const aggregatedValue = eoStatusRuntime.values.reduce(
            (
              acc: number,
              value: { value: number; properties: { [x: string]: string } }
            ) => {
              if (value.properties) {
                if (
                  !eoStatusRuntime.values.some(
                    (v: { properties: { [x: string]: any } }) =>
                      v.properties && v.properties[mapping[key]]
                  )
                ) {
                  return '--';
                } else if (value.properties[mapping[key]]) {
                  return typeof acc === 'number'
                    ? acc + parseFloat(value.properties[mapping[key]])
                    : parseFloat(value.properties[mapping[key]]);
                }
              }
              return acc;
            },
            0
          );
          addEoStatusRow(aggregatedValue, format(start, 'MMM yyyy'));
        } else if (diffDays <= 7) {
          eoStatusRuntime.values.forEach(
            (value: {
              value: number;
              dataTimeStamp: string | number | Date;
              properties: { [x: string]: string };
            }) => {
              const date = new Date(value.dataTimeStamp);
              const formattedDate = format(date, 'dd MMM - EEE');
              if (columns.some((col) => col.field === formattedDate)) {
                const hours =
                  value.properties && value.properties[mapping[key]]
                    ? parseFloat(value.properties[mapping[key]])
                    : undefined;

                addEoStatusRow(hours, formattedDate, 24);
              }
            }
          );
          // Check for missing dates and add "--" for those dates
          const startDate = new Date(startTime);
          const endDate = new Date(endTime);
          for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
            const formattedDate = format(d, 'dd MMM - EEE');
            if (
              !row[formattedDate] &&
              columns.some((col) => col.field === formattedDate)
            ) {
              row[formattedDate] = '--';
            }
          }
        }
        return row;
      });

      columns.forEach((col) => {
        if (col.field !== 'parameters') {
          eoOperationOverviewRow[col.field] = '';
        }
      });

      eoStatusData.unshift(eoOperationOverviewRow);

      columns.forEach((col) => {
        if (col.field !== 'parameters') {
          let columnTotal = 0;
          eoStatusData.forEach((row) => {
            if (row[col.field]) {
              const hours = parseFloat(row[col.field].split(' ')[0]);
              columnTotal += hours ? hours : 0;
            }
          });
          eoStatusData.forEach((row) => {
            if (row[col.field]) {
              const hours = parseFloat(row[col.field].split(' ')[0]);

              const percentage =
                columnTotal > 0 ? (hours * 100) / columnTotal : 0;
              row[col.field] =
                hours >= 0
                  ? row[col.field]
                  : // `${hours.toFixed(1)} hrs`
                    // (${percentage.toFixed()}%)
                    '--';
            }
          });
        }
      });

      transformedData.push(...eoStatusData);
    } else {
      // If eoStatusRuntime is false, populate eoStatusData with "--" for each date in the range
      const eoStatusData = Object.keys(mapping).map((key) => {
        const row: { parameters: string; [key: string]: any } = {
          parameters: key
        };

        if (diffMonths > 12) {
          let currentYear = startOfYear(start);
          while (currentYear <= end) {
            row[format(currentYear, 'yyyy')] = '--';
            currentYear = addMonths(currentYear, 12);
          }
        } else if (diffDays > 7) {
          let currentMonth = startOfMonth(start);
          while (currentMonth <= end) {
            row[format(currentMonth, 'MMMM yyyy')] = '--';
            currentMonth = addMonths(currentMonth, 1);
          }
        } else if (isSameMonth(start, end) && diffDays === daysInMonth) {
          row[format(start, 'MMM yyyy')] = '--';
        } else if (diffDays <= 7) {
          const startDate = new Date(startTime);
          const endDate = new Date(endTime);
          for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
            const formattedDate = format(d, 'dd MMM - EEE');
            row[formattedDate] = '--';
          }
        }
        return row;
      });
      columns.forEach((col) => {
        if (col.field !== 'parameters') {
          eoOperationOverviewRow[col.field] = '';
        }
      });

      eoStatusData.unshift(eoOperationOverviewRow);

      columns.forEach((col) => {
        if (col.field !== 'parameters') {
          let columnTotal = 0;
          eoStatusData.forEach((row) => {
            if (row[col.field]) {
              const hours = parseFloat(row[col.field].split(' ')[0]);
              columnTotal += hours ? hours : 0;
            }
          });
          eoStatusData.forEach((row) => {
            if (row[col.field]) {
              const hours = parseFloat(row[col.field].split(' ')[0]);

              const percentage =
                columnTotal > 0 ? (hours * 100) / columnTotal : 0;
              row[col.field] =
                hours >= 0
                  ? `${hours.toFixed(1)} hrs (${percentage.toFixed()}%)`
                  : '--';
            }
          });
        }
      });

      transformedData.push(...eoStatusData);
    }
    if (!isAllUtility && dataOp && dataOp.dataItems) {
      columns.forEach((col) => {
        if (col.field !== 'parameters') {
          operationParametersRow[col.field] = '';
        }
      });
      transformedData.push(operationParametersRow);
    }
    // Add rows for dataOp
    if (!isAllUtility && dataOp && dataOp.dataItems) {
      const countName: { [key: string]: number } = {};
      dataOp.dataItems.forEach(
        (item: { name: any; value: any[]; unit: any }) => {
          if (countName[item?.name] === undefined) {
            countName[item?.name] = 0;
          } else {
            countName[item?.name] += 1;
          }
          const updatedName = splitStringWithSpace(item?.name);
          const row: { parameters: string; [key: string]: any } = {
            parameters: `${updatedName}. Avg ${
              countName[item?.name] !== 0 ? countName[item?.name] : ''
            }`
          };

          if (diffMonths > 12) {
            let currentYear = startOfYear(start);
            while (currentYear <= end) {
              const yearEnd = endOfYear(currentYear);
              const hasDataForYear = item.value.some(
                (value: { sampleTime: string | number | Date }) => {
                  const date = new Date(value.sampleTime);
                  return date >= currentYear && date <= yearEnd;
                }
              );
              if (!hasDataForYear) {
                row[format(currentYear, 'yyyy')] = '--';
              } else {
                const { sum, count } = item.value.reduce(
                  (
                    acc: { sum: number; count: number },
                    value: { sampleTime: string | number | Date; value: any }
                  ) => {
                    const date = new Date(value.sampleTime);
                    if (date >= currentYear && date <= yearEnd && value.value) {
                      acc.sum += value.value;
                      acc.count += 1;
                    }
                    return acc;
                  },
                  { sum: 0, count: 0 }
                );
                const averageValue = count > 0 ? sum / count : 0;

                row[format(currentYear, 'yyyy')] = `${
                  averageValue && averageValue !== null
                    ? Number(
                        UnitUtility.convertValue(
                          item.unit,
                          apiContext.userSelectedTemperatureUnit
                            ? apiContext.userSelectedTemperatureUnit
                            : 'celsius',
                          averageValue
                        )
                      ).toFixed(1)
                    : ''
                } ${
                  averageValue
                    ? getUnitSymbolForTemp(
                        apiContext.userSelectedTemperatureUnit
                          ? apiContext.userSelectedTemperatureUnit
                          : 'celsius'
                      )
                    : '--'
                }`;
              }
              currentYear = addMonths(currentYear, 12);
            }
          } else if (diffDays > 7) {
            let currentMonth = startOfMonth(start);
            while (currentMonth <= end) {
              const monthEnd = endOfMonth(currentMonth);
              const hasDataForMonth = item.value.some(
                (value: { sampleTime: string | number | Date }) => {
                  const date = new Date(value.sampleTime);
                  return date >= currentMonth && date <= monthEnd;
                }
              );
              if (!hasDataForMonth) {
                row[format(currentMonth, 'MMMM yyyy')] = '--';
              } else {
                const { sum, count } = item.value.reduce(
                  (
                    acc: { sum: number; count: number },
                    value: { sampleTime: string | number | Date; value: any }
                  ) => {
                    const date = new Date(value.sampleTime);
                    if (
                      date >= currentMonth &&
                      date <= monthEnd &&
                      value.value
                    ) {
                      acc.sum += value.value;
                      acc.count += 1;
                    }
                    return acc;
                  },
                  { sum: 0, count: 0 }
                );

                const averageValue = count > 0 ? sum / count : 0;

                row[format(currentMonth, 'MMMM yyyy')] = `${
                  averageValue && averageValue !== null
                    ? Number(
                        UnitUtility.convertValue(
                          item.unit,
                          apiContext.userSelectedTemperatureUnit
                            ? apiContext.userSelectedTemperatureUnit
                            : 'celsius',
                          averageValue
                        )
                      ).toFixed(1)
                    : ''
                } ${
                  averageValue
                    ? getUnitSymbolForTemp(
                        apiContext.userSelectedTemperatureUnit
                          ? apiContext.userSelectedTemperatureUnit
                          : 'celsius'
                      )
                    : '--'
                }`;
              }
              currentMonth = addMonths(currentMonth, 1);
            }
          } else if (isSameMonth(start, end) && diffDays === daysInMonth) {
            const hasDataForMonth = item.value.some(
              (value: { sampleTime: string | number | Date }) => {
                const date = new Date(value.sampleTime);
                return date >= start && date <= end;
              }
            );
            if (!hasDataForMonth) {
              row[format(start, 'MMM yyyy')] = '--';
            } else {
              const { sum, count } = item.value.reduce(
                (
                  acc: { sum: number; count: number },
                  value: { sampleTime: string | number | Date; value: any }
                ) => {
                  const date = new Date(value.sampleTime);
                  if (date >= start && date <= end && value.value) {
                    acc.sum += value.value;
                    acc.count += 1;
                  }
                  return acc;
                },
                { sum: 0, count: 0 }
              );
              const averageValue = count > 0 ? sum / count : 0;
              row[format(start, 'MMM yyyy')] = `${
                averageValue && averageValue !== null
                  ? Number(
                      UnitUtility.convertValue(
                        item.unit,
                        apiContext.userSelectedTemperatureUnit
                          ? apiContext.userSelectedTemperatureUnit
                          : 'celsius',
                        averageValue
                      )
                    ).toFixed(1)
                  : ''
              } ${
                averageValue
                  ? getUnitSymbolForTemp(
                      apiContext.userSelectedTemperatureUnit
                        ? apiContext.userSelectedTemperatureUnit
                        : 'celsius'
                    )
                  : '--'
              }`;
            }
          } else if (diffDays <= 7) {
            item.value.forEach(
              (value: { sampleTime: string | number | Date; value: any }) => {
                const date = new Date(value.sampleTime);
                const formattedDate = format(date, 'dd MMM - EEE');

                if (columns.some((col) => col.field === formattedDate)) {
                  row[formattedDate] = `${
                    value.value && value.value !== null
                      ? Number(
                          UnitUtility.convertValue(
                            item.unit,
                            apiContext.userSelectedTemperatureUnit
                              ? apiContext.userSelectedTemperatureUnit
                              : 'celsius',
                            value.value
                          )
                        ).toFixed(1)
                      : ''
                  } ${
                    value.value
                      ? getUnitSymbolForTemp(
                          apiContext.userSelectedTemperatureUnit
                            ? apiContext.userSelectedTemperatureUnit
                            : 'celsius'
                        )
                      : '--'
                  }`;
                }
              }
            );
            // Check for missing dates and add "--" for those dates
            const startDate = new Date(startTime);
            const endDate = new Date(endTime);
            for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
              const formattedDate = format(d, 'dd MMM - EEE');
              if (
                !row[formattedDate] &&
                columns.some((col) => col.field === formattedDate)
              ) {
                row[formattedDate] = '--';
              }
            }
          }
          transformedData.push(row);
        }
      );
    }

    setTableData(transformedData);
  }, [startTime, endTime, dataOp, data, apiContext.eoActiveHours]);

  const getColumns = (
    start: Date,
    end: Date,
    diffDays: number,
    diffMonths: number,
    daysInMonth: number
  ) => {
    const columns = [{ field: 'parameters', header: 'Parameters' }];

    if (diffMonths > 12) {
      let currentYear = startOfYear(start);
      while (currentYear <= end) {
        columns.push({
          field: format(currentYear, 'yyyy'),
          header: format(currentYear, 'yyyy')
        });
        currentYear = addMonths(currentYear, 12);
      }
    } else if (diffDays > 7) {
      let currentMonth = startOfMonth(start);
      while (currentMonth <= end) {
        columns.push({
          field: format(currentMonth, 'MMMM yyyy'),
          header: format(currentMonth, 'MMMM yyyy')
        });
        currentMonth = addMonths(currentMonth, 1);
      }
    } else if (isSameMonth(start, end) && diffDays === daysInMonth) {
      columns.push({
        field: format(start, 'MMM yyyy'),
        header: format(start, 'MMM yyyy')
      });
    } else if (diffDays <= 7) {
      for (let i = 0; i < diffDays; i++) {
        const date = new Date(start);
        date.setDate(start.getDate() + i);
        columns.push({
          field: format(date, 'dd MMM - EEE'),
          header: format(date, 'dd MMM - EEE')
        });
      }
    }
    return columns;
  };

  function statusRenderer(cellData: ICellData) {
    return <span className="EOColumnValue">{cellData.value}</span>;
  }

  return (
    <>
      <span className="eoTableHeading">{t(d.EOSUMMARY)}</span>
      <DataTable
        scrollable={true}
        resizableColumns={true}
        data={tableData}
        className="EOCustomTableData"
      >
        {getColumns(
          new Date(startTime),
          new Date(endTime),
          differenceInDays(new Date(endTime), new Date(startTime)) + 1,
          differenceInMonths(new Date(endTime), new Date(startTime)) + 1,
          getDaysInMonth(new Date(startTime))
        ).map((col) => (
          <DataTable.Column
            initialWidth={col.header === 'Parameters' ? '300px' : '200px'}
            key={col.field}
            field={col.field}
            header={col.header}
            renderer={statusRenderer}
          />
        ))}
      </DataTable>
    </>
  );
};

export default EnergyOptimizationTableWidget;
